<!-- eslint-disable vuejs-accessibility/no-static-element-interactions -->
<!-- eslint-disable vuejs-accessibility/click-events-have-key-events -->
<template>
    <div class="contract-list">
        <div v-if="$route.name === 'userContracts'">
            <ul class="nav">
                <li class="nav-item">
                    <div class="d-flex">
                        <a class="nav-link requests" :class="{ 'active': selectedTab.name === 'ApprovedContracts' }"
                           @click="onTabSelected({ name: 'ApprovedContracts', type: 'Contract' })" aria-current="page">العقود المعتمدة</a>
                        <!--<a class="nav-link requests" :class="{ 'active': selectedTab.name === 'MyRequests' }"
                          @click="onTabSelected({ name: 'MyRequests', type: 'Request' })" aria-current="page">طلباتي</a>
                        <a class="nav-link requests" :class="{ 'active': selectedTab.name === 'PendingRequests' }"
                          @click="onTabSelected({ name: 'PendingRequests', type: 'Request' })" aria-current="page">طلبات المصادقة</a>-->
                    </div>
                </li>
            </ul>
            <hr style="width:100%;margin-top:0px;padding-top:0px;">
            <SearchComponent ref="searchForm" v-show="showSearch" :tab="selectedTab" @search="onSearch($event)"
                             @reset="onReset" />
            <template v-if="items.length > 0">
                <template v-for="(item, index) in items">
                    <ItemComponent :key="index" :tab="selectedTab" :item="item" @click:details="onDetails($event)"
                                   @click:download="onDownload($event)" />
                </template>
                <div class="text-center">
                    <v-container>
                        <v-row justify="center">
                            <v-col cols="8">
                                <v-container class="max-width">
                                    <v-pagination v-model="pageNumber" class="my-4" :length="totalPages"
                                                  @input="onPagination"></v-pagination>
                                </v-container>
                            </v-col>
                        </v-row>
                    </v-container>
                </div>
            </template>
            <template v-else-if="items.length == 0">

                <div class="row">
                    <div class="col-md-12">
                        <div class="List__empty">
                            <img src="../../../public/img/folder-empty.svg" alt="No Data">
                            <h4 class="List__title">{{ errorMessage }}</h4>
                        </div>
                    </div>
                </div>


                <!--<div class="listing-cont loaded closed">-->
                <!---->
                <!--<div class="issueProcuration" style="padding-top: 50px;">
                        <div class="text-center py-5"><img src="../../../public/img/folder-empty.svg" class="align-middle px-2"></div>
                        <h4 class="text-center py-3">
                            {{ errorMessage }}
                        </h4>
                    </div>
                </div>-->
            </template>
            <!--<AlertComponent v-else-if="errorMessage" :type="'danger'">{{ errorMessage }}</AlertComponent>-->
        </div>
        <router-view></router-view>
    </div>
</template>
<style>
    .issueProcuration {
        padding-left: 104px !important;
        padding-right: 124px !important;
    }

    .List__empty {
        -ms-flex-align: center;
        align-items: center;
        border: 1px solid #e4e5e6;
        display: flex;
        -webkit-flex-direction: column;
        -ms-flex-direction: column;
        flex-direction: column;
        -webkit-flex-grow: 1;
        -ms-flex-positive: 1;
        flex-grow: 1;
        -webkit-justify-content: center;
        -ms-flex-pack: center;
        justify-content: center;
        margin-top: 33px;
        padding: 16px
    }

    .List__title {
        font-size: 32px;
        line-height: 43px;
        margin: 32px 0 15px
    }
</style>
<script lang="ts">
    import { Component, Vue } from 'vue-property-decorator';
    import { Inject } from 'vue-di-container';

    import AlertComponent from '@/components/alert.component.vue';
    import DropDownCalendarComponent from '@/components/dropDownCalendar.vue';
    import { FilterName, createContractFilter, createRequestFilter } from '@/models/contractFilterModel';
    import { ContractModel } from '@/models/contractDetailsModel';
    import UserModel from '@/models/user';
    import ContractService from '@/services/contract.service';
    import ContractTemplateService from '@/services/contractTemplateService';
    import { Toaster } from '@/services/toast';
    import UserService from '@/services/user';
    import { Tab } from './tab.model';
    import SearchComponent from './search.component.vue';
    import ItemComponent from './item.component.vue';
    import { Utils } from '@/utils/utils';

    @Component({
        components: {
            DropDownCalendarComponent,
            AlertComponent,
            SearchComponent,
            ItemComponent,
        },
        diProvide: [
            UserService,
            ContractTemplateService,
            ContractService,
        ],
    })
    export default class UserContracts extends Vue {
        @Inject(UserService) public userService!: UserService;
        @Inject(ContractTemplateService) public contractTemplateService!: ContractTemplateService;
        @Inject(ContractService) public contractService!: ContractService;

        /** The current logged in user info. */
        currentUser!: UserModel;

        /** The contract list used to populate the grid. */
        items = [] as ContractModel[];
        pageNumber = 1;
        pageSize = 10;
        totalPages = 5;

        /** Holds the search filter data for contracts and requests. */
        filter!: any;

        /** Used to toggle the search input field control. */
        showSearch = false;

        /** Used to determine the selected tab. */
        selectedTab: Tab = { name: 'ApprovedContracts', type: 'Contract' };

        /** Used to display error messages. */
        errorMessage = '';

        async mounted(): Promise<void> {
            if (this.$route.params.page) {
                this.pageNumber = parseInt(this.$route.params.page.toString(), 10);
            }

            this.currentUser = await this.userService.getUser();
            //console.log("this.$route.name:", this.$router.name);
            //alert(this.$router.name);
            if (this.currentUser) {
                this.populateList(this.selectedTab).finally(() => {
                    this.showSearch = !!(this.items && this.items.length);
                });
            }
        }

        /**
         * Used to render the selected tab type.
         * @param tab The selected tab to be rendered.
         */
        onTabSelected(tab: Tab): void {
            // Do nothing if it's the same tab.
            if (this.selectedTab.name === tab.name) return;

            // Reset the pagination.
            this.pageNumber = 1;

            // Set a period of time for animation to take place.
            let delay = 0;

            // Reset the search form.
            const searchForm = (this.$refs.searchForm as any);
            delay = searchForm?.showAdvancedSearch ? 800 : 0;
            searchForm.reset(tab);

            // Load and populate the list.
            setTimeout(() => {
                this.populateList(tab).finally(() => {
                    // Show the search form if there is data, otherwise hide it.
                    this.showSearch = !!(this.items && this.items.length);

                    // Update the selected tab value.
                    this.selectedTab = tab;
                });
            }, delay);
        }

        /**
         * Populates the grid list.
         * @param tab The current selected tab.
         * @param filter Filters the data based on.
         * @returns A list of requests or contracts.
         */
        populateList(tab: Tab, filter?: any): Promise<ContractModel[] | void> {
            return new Promise((resolve, reject) => {
                if (!this.currentUser?.username) {
                    Toaster.error({ message: 'بيانات المستخدم غير صحيحة' });
                    reject(new Error('Invalid user data.'));
                }


                const query = {
                    pageNumber: this.pageNumber,
                    pageSize: this.pageSize,
                    isRequests: tab.type === 'Request',
                    filterData: filter || (tab.type === 'Contract' ? createContractFilter() : createRequestFilter()),
                };





                this.contractService.getContracts(tab.name, query).then((response) => {
                    if (response && response.model && response.model.length > 0) {

                        this.items = response.model;
                        this.totalPages = response.pagingModel.totalPages;
                        this.pageSize = response.pagingModel.pageSize;
                        this.items.map((c) => c.statusClass = tab.type === 'Contract' ? Utils.getContractStatusCssClass(c.statusId) : Utils.getRequestStatusCssClass(c.statusId));

                        if (this.$route.name === 'userContracts' && this.$route.path !== `/user-contracts/${this.pageNumber}`) {
                            this.$router.push(`/user-contracts/${this.pageNumber}`);
                        }
                        resolve(response.model);
                    } else {

                        Toaster.error({ message: 'عذرًا، الخدمه غير متاحه' });

                    }

                }, (err) => {
                    this.items = [] as ContractModel[];
                    reject(err);
                }).finally(() => {

                    if (!this.items.length) {
                        const searchForm = (this.$refs.searchForm as any);
                        this.showError(searchForm?.isFilterChanged || this.selectedTab.name);
                    }
                });
            });
        }

        /**
         * Performs the search process.
         * @param filter The current filter applied by the logged-in user.
         */
        onSearch(filter: any): void {
            this.filter = filter;
            this.populateList(this.selectedTab, filter).then(() => {
                const searchForm = (this.$refs.searchForm as any);
                searchForm.showAdvancedSearch = false;
                searchForm.showDataFilteredIndicator = searchForm.isFilterChanged;
            });
        }

        /**
         * Resets and populates the list.
         */
        onReset(filter: any): void {
            this.filter = filter;
            this.items = [] as ContractModel[];
            this.pageNumber = 1;
            this.populateList(this.selectedTab).then(() => {
                const searchForm = (this.$refs.searchForm as any);
                searchForm.showAdvancedSearch = false;
                searchForm.showDataFilteredIndicator = false;
            });
        }

        /**
         * Populate the list based on the current selected page.
         */
        onPagination(): void {
            this.populateList(this.selectedTab, this.filter);
        }

        /**
         * Navigates to the item details view.
         * @param code The item code.
         */
        onDetails(code: number): void {
            if (!code) return;

            this.$router.push({ name: this.selectedTab.type === 'Contract' ? 'contractDetails' : 'requestDetails', params: { id: `${code}` } });
        }

        /**
         * Download the item by code.
         * @param code The item code.
         */
        onDownload(code: number): void {
            this.contractService.getContractAsPDF(code).then((response) => {
                const linkSource = `data:application/pdf;base64,${response.model}`;
                const downloadLink = document.createElement('a');
                const fileName = `${code}.pdf`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            });
        }

        /**
         * A helper method is used to show an error message when the populating list process fails for a certain reason.
         * @param indicator A boolean or tab to show the proper error message.
         */
        private showError(indicator: boolean | FilterName): void {
            if (typeof indicator === 'boolean' && indicator) {
                this.errorMessage = 'لا توجد نتائج مطابقة لمدخلاتك';
            } else if (indicator === 'ApprovedContracts') {
                this.errorMessage = 'لا توجد عقود خاصة بك';
            } else if (indicator === 'MyRequests') {
                this.errorMessage = 'لا توجد طلبات خاصة بك';
            } else if (indicator === 'PendingRequests') {
                this.errorMessage = 'لا توجد طلبات مصادقة خاصة بك';
            }
        }
    }
</script>
